import React, { useState, useEffect } from "react";
import { Form, InputGroup } from "react-bootstrap";
import FeatherIcon from 'feather-icons-react';
import i18n from "../../../../../../_translations/i18n";


const dataPanelSearchBar = ({ activeTab, onSearch, toSimulateProduct, filterSimulatedDataFunction, onSearchModeChange }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredList, setFilteredList] = useState("")

  const isDarkMode = document.body.classList.contains('d-mode');

  // console.log('tosimulateProd',toSimulateProduct)
  useEffect(() => {
    setSearchQuery('')
    onSearch('')
    filterSimulatedDataFunction('', activeTab)
    if (onSearchModeChange) {
      onSearchModeChange(false)
    }
  }, [activeTab]);

  const handleChange = (e) => {
    // console.log(e.target.value);
    setSearchQuery(e.target.value);
    filterSimulatedDataFunction(e.target.value, activeTab)
    onSearch(e.target.value);
    if (onSearchModeChange) {
      onSearchModeChange(e.target.value.length > 0)
    }
  };

  const clearSearchQuery = () =>{
    setSearchQuery('');
    filterSimulatedDataFunction('', activeTab)
    onSearch('');
    if (onSearchModeChange) {
      onSearchModeChange(false)
    }
  }

  return (
    <InputGroup
      style={{
        alignItems: 'center',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        padding: '2px 8px',
        background: isDarkMode ? '#22272f' : '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
      }}
    >
      <span><FeatherIcon icon="search" size={22} color={isDarkMode ? '#fff' : undefined} /></span>
      <Form.Control
        type="text"
        placeholder={i18n.t('SEARCH_HERE')}
        value={searchQuery}
        onChange={handleChange}
        style={{
          border: "none",
          boxShadow: "none",
          background: "transparent",
          color: isDarkMode ? '#fff' : undefined
        }}
      />
      <span
        style={{
          // marginLeft: 5,
          cursor: "pointer",
          transition: "opacity 0.2s"
        }}
        onClick={clearSearchQuery}
        onMouseOver={e => (e.currentTarget.style.opacity = 0.5)}
        onMouseOut={e => (e.currentTarget.style.opacity = 1)}
      >
        <FeatherIcon icon="x-circle" size={22} color={isDarkMode ? '#fff' : undefined} />
      </span>
    </InputGroup>
  );
};

export default dataPanelSearchBar;